import React, { useState } from 'react';
import {ReactComponent as DotIcon} from '../svgs/dotIcon.svg'

const UploadButton = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {selectedImage && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginRight: '8px' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={URL.createObjectURL(selectedImage)}
              alt={selectedImage.name}
              style={{ width: '16px', height: '16px', marginRight: '4px' }}
            />
            <span style={{ fontSize: '14px' }}>{selectedImage.name}</span>
          </div>
          <div style={{ fontSize: '12px', color: '#666', display: 'flex', gap: '10px' }}>
            {selectedImage.type} <DotIcon className='mt-2.5'/> {(selectedImage.size / 1024).toFixed(2)} KB
          </div>
        </div>
      )}
      <div className='upload-btn-container'>
      <label htmlFor="upload-input"  style={{
            cursor: 'pointer',
            borderRadius: '8px',
            color: '#FFF',
            padding: '8px 16px',
            textAlign: 'center',
            textDecoration: 'none',
            display: 'inline-block',
            fontSize: '1.4rem',
            margin: '4px 2px',
            backgroundColor: '#529FBE',
            width: '120px',
            height: '38px'
        }}>
        Change logo
      </label>
      </div>
      <input
        id="upload-input"
        type="file"
        accept="image/*"
        onChange={handleImageUpload}
        style={{ display: 'none' }}
        // value={value}
      />
    </div>
  );
};

export default UploadButton;